import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-button-spinner',
    templateUrl: './button-spinner.component.html',
    styleUrl: './button-spinner.component.scss',
})
export class ButtonSpinnerComponent {
    @Input() size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | '3xl' = 'md';
    @Input() color: 'white' | 'blue' | 'primary' | 'black' | 'disabled' | 'inherit' = 'inherit';

    circles = new Array(8);

    get spinnerContainerClass(): string {
        const classes = [];

        if (this.size !== 'md') {
            classes.push(`spinner-circles-container--${this.size}`);
        }

        return classes.join(' ');
    }

    get spinnerClasses(): string {
        const classes = [];

        // Size Modifiers
        classes.push(this.size == 'md' ? `spinner-circles-custom` : `spinner-circles-custom--${this.size}`);

        // Color Modifiers
        if (this.color !== 'inherit') {
            classes.push(`spinner-circles-custom--${this.color}`);
        }

        return classes.join(' ');
    }
}
